import { Box, Paper, TextField, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import CustomTypography from "./CustomTypography";
import CustomAutocomplete from "./CustomAutoComplete";
import theme from "../../assets/theme";

const StyledAutocomplete = ({ label, options, value, onChange, disabled, ...props }) => {
  const inputBoxStyle = {
    "& .MuiOutlinedInput-root": {
      borderRadius: theme.borderRadius.medium,
      backgroundColor: disabled
        ? theme.palette.lightgray.light
        : theme.palette.lightgray.main,
      "& fieldset": {
        borderColor: theme.palette.gray.main,
      },
      "&:hover fieldset": {
        borderColor: disabled
          ? theme.palette.gray.main
          : theme.palette.primary.main,
      },
      "&.Mui-focused": {
        backgroundColor: disabled
          ? theme.palette.lightgray.light
          : theme.palette.light.main,
        "& fieldset": {
          borderColor: disabled
            ? theme.palette.gray.main
            : theme.palette.primary.main,
        },
      },
    },
  };

  const autocompletePaperStyle = {
    "& .MuiAutocomplete-option": {
      "&:hover": {
        backgroundColor:" rgb(255, 247, 231)",
      },
    },
    borderRadius: theme.borderRadius.medium,
    backgroundColor: theme.palette.light.main,
  };

  return (
    <Box sx={{ width: '100%' }}>
      {label && (
        <CustomTypography
          variant="bodyText1"
          display="block"
          gutterBottom
          color="dark.main"
        >
          {label}
        </CustomTypography>
      )}
      <CustomAutocomplete
        options={options}
        value={value}
        onChange={onChange}
        size="small"
        disabled={disabled}
        fullWidth
        clearOnBlur={false}
        sx={inputBoxStyle}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select"
            disabled={disabled}
            InputProps={{
              ...params.InputProps,
              
            }}
          />
        )}
        PaperComponent={(props) => (
          <Paper {...props} sx={autocompletePaperStyle} />
        )}
        {...props}
      />
    </Box>
  );
};

export default StyledAutocomplete;